import { AssistanceRequest } from 'types/assistance-request';

export const getUnresolvedAssistanceRequests = (assistanceRequests: AssistanceRequest[]) =>
  assistanceRequests?.filter(a => !a?.isResolved);
